import { type ReactElement } from 'react';
import { History } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
    CredentialRotationDisabledReason,
} from '@anchorbase/pillar-sdk';
import { Button } from '@/components/ui/button';
import { getCredentialRotationDisabledReasonCopy } from './IpxCredentialRotationButton';

export interface IpxCredentialHistoryButtonProps {
    readonly canViewHistory: boolean;
    readonly disabledReason: CredentialRotationDisabledReason | null;
    readonly historyPath: string;
}

export function IpxCredentialHistoryButton(
    props: IpxCredentialHistoryButtonProps
): ReactElement {
    if (props.canViewHistory) {
        return (
            <Button asChild variant="outline" size="sm">
                <Link to={props.historyPath} title="View rotation history">
                    <History className="mr-2 h-4 w-4" />
                    History
                </Link>
            </Button>
        );
    }
    const title = getCredentialRotationDisabledReasonCopy(
        props.disabledReason,
        CredentialRotationDisabledReason.NOT_ADMIN_FOR_ORGANIZATION
    );
    return (
        <span className="inline-flex" title={title}>
            <Button
                type="button"
                variant="outline"
                size="sm"
                disabled
                title={title}
            >
                <History className="mr-2 h-4 w-4" />
                History
            </Button>
        </span>
    );
}
